/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRelatorioVendasRouteImport } from './routes/_authenticated/relatorio-vendas'
import { Route as AuthenticatedPerfilRouteImport } from './routes/_authenticated/perfil'
import { Route as AuthenticatedMetasLojaRouteImport } from './routes/_authenticated/metas-loja'
import { Route as AuthenticatedMetasIndividuaisRouteImport } from './routes/_authenticated/metas-individuais'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedGruposRouteImport } from './routes/_authenticated/grupos'
import { Route as AuthenticatedFotosRouteImport } from './routes/_authenticated/fotos'
import { Route as AuthenticatedFluxoCaixaRouteImport } from './routes/_authenticated/fluxo-caixa'
import { Route as AuthenticatedFinanceiroRouteImport } from './routes/_authenticated/financeiro'
import { Route as AuthenticatedEstoqueRouteImport } from './routes/_authenticated/estoque'
import { Route as AuthenticatedDreRouteImport } from './routes/_authenticated/dre'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedDadosHistoricosRouteImport } from './routes/_authenticated/dados-historicos'
import { Route as AuthenticatedConfiguracoesRouteImport } from './routes/_authenticated/configuracoes'
import { Route as AuthenticatedClientesRouteImport } from './routes/_authenticated/clientes'
import { Route as AuthenticatedConfiguracoesIndexRouteImport } from './routes/_authenticated/configuracoes/index'
import { Route as AuthenticatedCadastroIndexRouteImport } from './routes/_authenticated/cadastro/index'
import { Route as AuthenticatedConfiguracoesTarifaCartaoRouteImport } from './routes/_authenticated/configuracoes/tarifa-cartao'
import { Route as AuthenticatedConfiguracoesSaldoCaixaRouteImport } from './routes/_authenticated/configuracoes/saldo-caixa'
import { Route as AuthenticatedConfiguracoesMetasRouteImport } from './routes/_authenticated/configuracoes/metas'
import { Route as AuthenticatedConfiguracoesEstoqueFinalRouteImport } from './routes/_authenticated/configuracoes/estoque-final'
import { Route as AuthenticatedConfiguracoesCalendarioRouteImport } from './routes/_authenticated/configuracoes/calendario'
import { Route as AuthenticatedCadastroIdEditarRouteImport } from './routes/_authenticated/cadastro/$id/editar'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRelatorioVendasRoute =
  AuthenticatedRelatorioVendasRouteImport.update({
    id: '/relatorio-vendas',
    path: '/relatorio-vendas',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPerfilRoute = AuthenticatedPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMetasLojaRoute = AuthenticatedMetasLojaRouteImport.update({
  id: '/metas-loja',
  path: '/metas-loja',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMetasIndividuaisRoute =
  AuthenticatedMetasIndividuaisRouteImport.update({
    id: '/metas-individuais',
    path: '/metas-individuais',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGruposRoute = AuthenticatedGruposRouteImport.update({
  id: '/grupos',
  path: '/grupos',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFotosRoute = AuthenticatedFotosRouteImport.update({
  id: '/fotos',
  path: '/fotos',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFluxoCaixaRoute = AuthenticatedFluxoCaixaRouteImport.update({
  id: '/fluxo-caixa',
  path: '/fluxo-caixa',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFinanceiroRoute = AuthenticatedFinanceiroRouteImport.update({
  id: '/financeiro',
  path: '/financeiro',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEstoqueRoute = AuthenticatedEstoqueRouteImport.update({
  id: '/estoque',
  path: '/estoque',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDreRoute = AuthenticatedDreRouteImport.update({
  id: '/dre',
  path: '/dre',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDadosHistoricosRoute =
  AuthenticatedDadosHistoricosRouteImport.update({
    id: '/dados-historicos',
    path: '/dados-historicos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfiguracoesRoute =
  AuthenticatedConfiguracoesRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientesRoute = AuthenticatedClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConfiguracoesIndexRoute =
  AuthenticatedConfiguracoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedConfiguracoesRoute,
  } as any)
const AuthenticatedCadastroIndexRoute =
  AuthenticatedCadastroIndexRouteImport.update({
    id: '/cadastro/',
    path: '/cadastro/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfiguracoesTarifaCartaoRoute =
  AuthenticatedConfiguracoesTarifaCartaoRouteImport.update({
    id: '/tarifa-cartao',
    path: '/tarifa-cartao',
    getParentRoute: () => AuthenticatedConfiguracoesRoute,
  } as any)
const AuthenticatedConfiguracoesSaldoCaixaRoute =
  AuthenticatedConfiguracoesSaldoCaixaRouteImport.update({
    id: '/saldo-caixa',
    path: '/saldo-caixa',
    getParentRoute: () => AuthenticatedConfiguracoesRoute,
  } as any)
const AuthenticatedConfiguracoesMetasRoute =
  AuthenticatedConfiguracoesMetasRouteImport.update({
    id: '/metas',
    path: '/metas',
    getParentRoute: () => AuthenticatedConfiguracoesRoute,
  } as any)
const AuthenticatedConfiguracoesEstoqueFinalRoute =
  AuthenticatedConfiguracoesEstoqueFinalRouteImport.update({
    id: '/estoque-final',
    path: '/estoque-final',
    getParentRoute: () => AuthenticatedConfiguracoesRoute,
  } as any)
const AuthenticatedConfiguracoesCalendarioRoute =
  AuthenticatedConfiguracoesCalendarioRouteImport.update({
    id: '/calendario',
    path: '/calendario',
    getParentRoute: () => AuthenticatedConfiguracoesRoute,
  } as any)
const AuthenticatedCadastroIdEditarRoute =
  AuthenticatedCadastroIdEditarRouteImport.update({
    id: '/cadastro/$id/editar',
    path: '/cadastro/$id/editar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/clientes': typeof AuthenticatedClientesRoute
  '/configuracoes': typeof AuthenticatedConfiguracoesRouteWithChildren
  '/dados-historicos': typeof AuthenticatedDadosHistoricosRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dre': typeof AuthenticatedDreRoute
  '/estoque': typeof AuthenticatedEstoqueRoute
  '/financeiro': typeof AuthenticatedFinanceiroRoute
  '/fluxo-caixa': typeof AuthenticatedFluxoCaixaRoute
  '/fotos': typeof AuthenticatedFotosRoute
  '/grupos': typeof AuthenticatedGruposRoute
  '/home': typeof AuthenticatedHomeRoute
  '/metas-individuais': typeof AuthenticatedMetasIndividuaisRoute
  '/metas-loja': typeof AuthenticatedMetasLojaRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/relatorio-vendas': typeof AuthenticatedRelatorioVendasRoute
  '/configuracoes/calendario': typeof AuthenticatedConfiguracoesCalendarioRoute
  '/configuracoes/estoque-final': typeof AuthenticatedConfiguracoesEstoqueFinalRoute
  '/configuracoes/metas': typeof AuthenticatedConfiguracoesMetasRoute
  '/configuracoes/saldo-caixa': typeof AuthenticatedConfiguracoesSaldoCaixaRoute
  '/configuracoes/tarifa-cartao': typeof AuthenticatedConfiguracoesTarifaCartaoRoute
  '/cadastro/': typeof AuthenticatedCadastroIndexRoute
  '/configuracoes/': typeof AuthenticatedConfiguracoesIndexRoute
  '/cadastro/$id/editar': typeof AuthenticatedCadastroIdEditarRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/clientes': typeof AuthenticatedClientesRoute
  '/dados-historicos': typeof AuthenticatedDadosHistoricosRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dre': typeof AuthenticatedDreRoute
  '/estoque': typeof AuthenticatedEstoqueRoute
  '/financeiro': typeof AuthenticatedFinanceiroRoute
  '/fluxo-caixa': typeof AuthenticatedFluxoCaixaRoute
  '/fotos': typeof AuthenticatedFotosRoute
  '/grupos': typeof AuthenticatedGruposRoute
  '/home': typeof AuthenticatedHomeRoute
  '/metas-individuais': typeof AuthenticatedMetasIndividuaisRoute
  '/metas-loja': typeof AuthenticatedMetasLojaRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/relatorio-vendas': typeof AuthenticatedRelatorioVendasRoute
  '/configuracoes/calendario': typeof AuthenticatedConfiguracoesCalendarioRoute
  '/configuracoes/estoque-final': typeof AuthenticatedConfiguracoesEstoqueFinalRoute
  '/configuracoes/metas': typeof AuthenticatedConfiguracoesMetasRoute
  '/configuracoes/saldo-caixa': typeof AuthenticatedConfiguracoesSaldoCaixaRoute
  '/configuracoes/tarifa-cartao': typeof AuthenticatedConfiguracoesTarifaCartaoRoute
  '/cadastro': typeof AuthenticatedCadastroIndexRoute
  '/configuracoes': typeof AuthenticatedConfiguracoesIndexRoute
  '/cadastro/$id/editar': typeof AuthenticatedCadastroIdEditarRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/clientes': typeof AuthenticatedClientesRoute
  '/_authenticated/configuracoes': typeof AuthenticatedConfiguracoesRouteWithChildren
  '/_authenticated/dados-historicos': typeof AuthenticatedDadosHistoricosRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/dre': typeof AuthenticatedDreRoute
  '/_authenticated/estoque': typeof AuthenticatedEstoqueRoute
  '/_authenticated/financeiro': typeof AuthenticatedFinanceiroRoute
  '/_authenticated/fluxo-caixa': typeof AuthenticatedFluxoCaixaRoute
  '/_authenticated/fotos': typeof AuthenticatedFotosRoute
  '/_authenticated/grupos': typeof AuthenticatedGruposRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/metas-individuais': typeof AuthenticatedMetasIndividuaisRoute
  '/_authenticated/metas-loja': typeof AuthenticatedMetasLojaRoute
  '/_authenticated/perfil': typeof AuthenticatedPerfilRoute
  '/_authenticated/relatorio-vendas': typeof AuthenticatedRelatorioVendasRoute
  '/_authenticated/configuracoes/calendario': typeof AuthenticatedConfiguracoesCalendarioRoute
  '/_authenticated/configuracoes/estoque-final': typeof AuthenticatedConfiguracoesEstoqueFinalRoute
  '/_authenticated/configuracoes/metas': typeof AuthenticatedConfiguracoesMetasRoute
  '/_authenticated/configuracoes/saldo-caixa': typeof AuthenticatedConfiguracoesSaldoCaixaRoute
  '/_authenticated/configuracoes/tarifa-cartao': typeof AuthenticatedConfiguracoesTarifaCartaoRoute
  '/_authenticated/cadastro/': typeof AuthenticatedCadastroIndexRoute
  '/_authenticated/configuracoes/': typeof AuthenticatedConfiguracoesIndexRoute
  '/_authenticated/cadastro/$id/editar': typeof AuthenticatedCadastroIdEditarRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/clientes'
    | '/configuracoes'
    | '/dados-historicos'
    | '/dashboard'
    | '/dre'
    | '/estoque'
    | '/financeiro'
    | '/fluxo-caixa'
    | '/fotos'
    | '/grupos'
    | '/home'
    | '/metas-individuais'
    | '/metas-loja'
    | '/perfil'
    | '/relatorio-vendas'
    | '/configuracoes/calendario'
    | '/configuracoes/estoque-final'
    | '/configuracoes/metas'
    | '/configuracoes/saldo-caixa'
    | '/configuracoes/tarifa-cartao'
    | '/cadastro/'
    | '/configuracoes/'
    | '/cadastro/$id/editar'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/clientes'
    | '/dados-historicos'
    | '/dashboard'
    | '/dre'
    | '/estoque'
    | '/financeiro'
    | '/fluxo-caixa'
    | '/fotos'
    | '/grupos'
    | '/home'
    | '/metas-individuais'
    | '/metas-loja'
    | '/perfil'
    | '/relatorio-vendas'
    | '/configuracoes/calendario'
    | '/configuracoes/estoque-final'
    | '/configuracoes/metas'
    | '/configuracoes/saldo-caixa'
    | '/configuracoes/tarifa-cartao'
    | '/cadastro'
    | '/configuracoes'
    | '/cadastro/$id/editar'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/clientes'
    | '/_authenticated/configuracoes'
    | '/_authenticated/dados-historicos'
    | '/_authenticated/dashboard'
    | '/_authenticated/dre'
    | '/_authenticated/estoque'
    | '/_authenticated/financeiro'
    | '/_authenticated/fluxo-caixa'
    | '/_authenticated/fotos'
    | '/_authenticated/grupos'
    | '/_authenticated/home'
    | '/_authenticated/metas-individuais'
    | '/_authenticated/metas-loja'
    | '/_authenticated/perfil'
    | '/_authenticated/relatorio-vendas'
    | '/_authenticated/configuracoes/calendario'
    | '/_authenticated/configuracoes/estoque-final'
    | '/_authenticated/configuracoes/metas'
    | '/_authenticated/configuracoes/saldo-caixa'
    | '/_authenticated/configuracoes/tarifa-cartao'
    | '/_authenticated/cadastro/'
    | '/_authenticated/configuracoes/'
    | '/_authenticated/cadastro/$id/editar'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/relatorio-vendas': {
      id: '/_authenticated/relatorio-vendas'
      path: '/relatorio-vendas'
      fullPath: '/relatorio-vendas'
      preLoaderRoute: typeof AuthenticatedRelatorioVendasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/perfil': {
      id: '/_authenticated/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthenticatedPerfilRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/metas-loja': {
      id: '/_authenticated/metas-loja'
      path: '/metas-loja'
      fullPath: '/metas-loja'
      preLoaderRoute: typeof AuthenticatedMetasLojaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/metas-individuais': {
      id: '/_authenticated/metas-individuais'
      path: '/metas-individuais'
      fullPath: '/metas-individuais'
      preLoaderRoute: typeof AuthenticatedMetasIndividuaisRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/grupos': {
      id: '/_authenticated/grupos'
      path: '/grupos'
      fullPath: '/grupos'
      preLoaderRoute: typeof AuthenticatedGruposRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fotos': {
      id: '/_authenticated/fotos'
      path: '/fotos'
      fullPath: '/fotos'
      preLoaderRoute: typeof AuthenticatedFotosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fluxo-caixa': {
      id: '/_authenticated/fluxo-caixa'
      path: '/fluxo-caixa'
      fullPath: '/fluxo-caixa'
      preLoaderRoute: typeof AuthenticatedFluxoCaixaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/financeiro': {
      id: '/_authenticated/financeiro'
      path: '/financeiro'
      fullPath: '/financeiro'
      preLoaderRoute: typeof AuthenticatedFinanceiroRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/estoque': {
      id: '/_authenticated/estoque'
      path: '/estoque'
      fullPath: '/estoque'
      preLoaderRoute: typeof AuthenticatedEstoqueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dre': {
      id: '/_authenticated/dre'
      path: '/dre'
      fullPath: '/dre'
      preLoaderRoute: typeof AuthenticatedDreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dados-historicos': {
      id: '/_authenticated/dados-historicos'
      path: '/dados-historicos'
      fullPath: '/dados-historicos'
      preLoaderRoute: typeof AuthenticatedDadosHistoricosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuracoes': {
      id: '/_authenticated/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AuthenticatedConfiguracoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clientes': {
      id: '/_authenticated/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AuthenticatedClientesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuracoes/': {
      id: '/_authenticated/configuracoes/'
      path: '/'
      fullPath: '/configuracoes/'
      preLoaderRoute: typeof AuthenticatedConfiguracoesIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracoesRoute
    }
    '/_authenticated/cadastro/': {
      id: '/_authenticated/cadastro/'
      path: '/cadastro'
      fullPath: '/cadastro/'
      preLoaderRoute: typeof AuthenticatedCadastroIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuracoes/tarifa-cartao': {
      id: '/_authenticated/configuracoes/tarifa-cartao'
      path: '/tarifa-cartao'
      fullPath: '/configuracoes/tarifa-cartao'
      preLoaderRoute: typeof AuthenticatedConfiguracoesTarifaCartaoRouteImport
      parentRoute: typeof AuthenticatedConfiguracoesRoute
    }
    '/_authenticated/configuracoes/saldo-caixa': {
      id: '/_authenticated/configuracoes/saldo-caixa'
      path: '/saldo-caixa'
      fullPath: '/configuracoes/saldo-caixa'
      preLoaderRoute: typeof AuthenticatedConfiguracoesSaldoCaixaRouteImport
      parentRoute: typeof AuthenticatedConfiguracoesRoute
    }
    '/_authenticated/configuracoes/metas': {
      id: '/_authenticated/configuracoes/metas'
      path: '/metas'
      fullPath: '/configuracoes/metas'
      preLoaderRoute: typeof AuthenticatedConfiguracoesMetasRouteImport
      parentRoute: typeof AuthenticatedConfiguracoesRoute
    }
    '/_authenticated/configuracoes/estoque-final': {
      id: '/_authenticated/configuracoes/estoque-final'
      path: '/estoque-final'
      fullPath: '/configuracoes/estoque-final'
      preLoaderRoute: typeof AuthenticatedConfiguracoesEstoqueFinalRouteImport
      parentRoute: typeof AuthenticatedConfiguracoesRoute
    }
    '/_authenticated/configuracoes/calendario': {
      id: '/_authenticated/configuracoes/calendario'
      path: '/calendario'
      fullPath: '/configuracoes/calendario'
      preLoaderRoute: typeof AuthenticatedConfiguracoesCalendarioRouteImport
      parentRoute: typeof AuthenticatedConfiguracoesRoute
    }
    '/_authenticated/cadastro/$id/editar': {
      id: '/_authenticated/cadastro/$id/editar'
      path: '/cadastro/$id/editar'
      fullPath: '/cadastro/$id/editar'
      preLoaderRoute: typeof AuthenticatedCadastroIdEditarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedConfiguracoesRouteChildren {
  AuthenticatedConfiguracoesCalendarioRoute: typeof AuthenticatedConfiguracoesCalendarioRoute
  AuthenticatedConfiguracoesEstoqueFinalRoute: typeof AuthenticatedConfiguracoesEstoqueFinalRoute
  AuthenticatedConfiguracoesMetasRoute: typeof AuthenticatedConfiguracoesMetasRoute
  AuthenticatedConfiguracoesSaldoCaixaRoute: typeof AuthenticatedConfiguracoesSaldoCaixaRoute
  AuthenticatedConfiguracoesTarifaCartaoRoute: typeof AuthenticatedConfiguracoesTarifaCartaoRoute
  AuthenticatedConfiguracoesIndexRoute: typeof AuthenticatedConfiguracoesIndexRoute
}

const AuthenticatedConfiguracoesRouteChildren: AuthenticatedConfiguracoesRouteChildren =
  {
    AuthenticatedConfiguracoesCalendarioRoute:
      AuthenticatedConfiguracoesCalendarioRoute,
    AuthenticatedConfiguracoesEstoqueFinalRoute:
      AuthenticatedConfiguracoesEstoqueFinalRoute,
    AuthenticatedConfiguracoesMetasRoute: AuthenticatedConfiguracoesMetasRoute,
    AuthenticatedConfiguracoesSaldoCaixaRoute:
      AuthenticatedConfiguracoesSaldoCaixaRoute,
    AuthenticatedConfiguracoesTarifaCartaoRoute:
      AuthenticatedConfiguracoesTarifaCartaoRoute,
    AuthenticatedConfiguracoesIndexRoute: AuthenticatedConfiguracoesIndexRoute,
  }

const AuthenticatedConfiguracoesRouteWithChildren =
  AuthenticatedConfiguracoesRoute._addFileChildren(
    AuthenticatedConfiguracoesRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedClientesRoute: typeof AuthenticatedClientesRoute
  AuthenticatedConfiguracoesRoute: typeof AuthenticatedConfiguracoesRouteWithChildren
  AuthenticatedDadosHistoricosRoute: typeof AuthenticatedDadosHistoricosRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDreRoute: typeof AuthenticatedDreRoute
  AuthenticatedEstoqueRoute: typeof AuthenticatedEstoqueRoute
  AuthenticatedFinanceiroRoute: typeof AuthenticatedFinanceiroRoute
  AuthenticatedFluxoCaixaRoute: typeof AuthenticatedFluxoCaixaRoute
  AuthenticatedFotosRoute: typeof AuthenticatedFotosRoute
  AuthenticatedGruposRoute: typeof AuthenticatedGruposRoute
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedMetasIndividuaisRoute: typeof AuthenticatedMetasIndividuaisRoute
  AuthenticatedMetasLojaRoute: typeof AuthenticatedMetasLojaRoute
  AuthenticatedPerfilRoute: typeof AuthenticatedPerfilRoute
  AuthenticatedRelatorioVendasRoute: typeof AuthenticatedRelatorioVendasRoute
  AuthenticatedCadastroIndexRoute: typeof AuthenticatedCadastroIndexRoute
  AuthenticatedCadastroIdEditarRoute: typeof AuthenticatedCadastroIdEditarRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedClientesRoute: AuthenticatedClientesRoute,
  AuthenticatedConfiguracoesRoute: AuthenticatedConfiguracoesRouteWithChildren,
  AuthenticatedDadosHistoricosRoute: AuthenticatedDadosHistoricosRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDreRoute: AuthenticatedDreRoute,
  AuthenticatedEstoqueRoute: AuthenticatedEstoqueRoute,
  AuthenticatedFinanceiroRoute: AuthenticatedFinanceiroRoute,
  AuthenticatedFluxoCaixaRoute: AuthenticatedFluxoCaixaRoute,
  AuthenticatedFotosRoute: AuthenticatedFotosRoute,
  AuthenticatedGruposRoute: AuthenticatedGruposRoute,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedMetasIndividuaisRoute: AuthenticatedMetasIndividuaisRoute,
  AuthenticatedMetasLojaRoute: AuthenticatedMetasLojaRoute,
  AuthenticatedPerfilRoute: AuthenticatedPerfilRoute,
  AuthenticatedRelatorioVendasRoute: AuthenticatedRelatorioVendasRoute,
  AuthenticatedCadastroIndexRoute: AuthenticatedCadastroIndexRoute,
  AuthenticatedCadastroIdEditarRoute: AuthenticatedCadastroIdEditarRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
